import styled from 'styled-components';

export const MaterialDefinitionsRowActionsStyled = styled.div`
    display: flex;
    gap: 8px;
`;
